
import React, { Fragment } from "react";
import _ from "lodash";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Checkbox,
  TableCell
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { PrimaryButton, SecondaryButton } from "components/Global/Buttons";
import styled from "styled-components";
import { EnhancedTable } from "components/Global/Table/EnhancedTable";

const StyledDialogIconButton = styled(IconButton)`
  && {
    position: absolute;
    top: 8px;
    right: 13px;
  }
`;

const StyledDialogContent = styled(DialogContent)`
  && {
    padding-right: 60px;
    color: #666;
    min-height: 500px;
  }
`;

const StyledCheckbox = styled(Checkbox)`
&&{
  margin-left:60px;
}
`;

const getTableColumns = (checkboxChecked, checkboxOnClick) => [
  {
    id: "groupName",
    label: "Name",
    isString: true,
    isBaseColumn: true,
    searchable: true,
    cellValueCalculator: group => `${group.name}`
  },
  {
    id: "add",
    label: "Add",
    actions: true,
    align: "right",
    cell: ({ data }) => (
      <TableCell>
        <StyledCheckbox
          checked={checkboxChecked(data)}
          onClick={() => checkboxOnClick(data)}
        />
      </TableCell>
    )
  }
];

/*
 *handleClose is whenever its closed with X
 *handleAccept is only when they click OK.
 *secondaryContent comes after message. Can be more text or another component
 */
export var SelectGuestGroupsModal = ({ modalOpen, handleClose, handleAccept, checkboxChecked, checkboxOnClick, guestGroups }) => (
  <Dialog fullWidth open={modalOpen} onClose={handleClose} id={"InfoDialog"}>
    <DialogTitle>Add Guest Group</DialogTitle>
    <StyledDialogIconButton onClick={handleClose}>
      <CloseIcon id="closeIcon" style={{ fontSize: 22 }} />
    </StyledDialogIconButton>
    <StyledDialogContent>

      <EnhancedTable
        searchable
        shouldHideConfig
        shouldHideExport
        sortable={false}
        orderBy={getTableColumns(checkboxChecked, checkboxOnClick)[0]}
        columnDefinitions={getTableColumns(checkboxChecked, checkboxOnClick)}
        rows={guestGroups ? guestGroups : []}
        noRowsMessage="No Guest Groups"
      />

    </StyledDialogContent>
    <DialogActions>
      <SecondaryButton id="dialogNo" onClick={handleClose}>{"Cancel"}</SecondaryButton>
      <PrimaryButton id="dialogOK" onClick={handleAccept}>{"ADD"}</PrimaryButton>
    </DialogActions>
  </Dialog>);
